import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../../Dashboard";

export const dummyParticipantsRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "emergency-calls/dummy-participants/$callId",
}).lazy(() => import("./DummyParticipants.lazy").then((d) => d.Route));
